export default __webpack_public_path__ + "admin-map-500-8642b3e4bdaa1769dcc9b1253d47dc67.png";